<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed()">
  @if (isRideBooker()) {
    <li nz-menu-item nzMatchRouter>
      <a [routerLink]="[path(), 'list']">
        <span nz-icon nzType="car"></span>
        <span> {{ 'shared.menu.ride.all' | translate }} </span>
      </a>
    </li>
    <li nz-menu-item nzMatchRouter>
      <a [routerLink]="[path(), 'book-transport']">
        <span nz-icon nzType="carry-out"></span>
        <span> {{ 'shared.menu.ride.bookTransport' | translate }} </span>
      </a>
    </li>
  }
  @if (isDispatcher()) {
    <li nz-menu-item nzMatchRouter>
      <a [routerLink]="[path(), 'accepted-rides']">
        <span nz-icon nzType="car"></span>
        <span> {{ 'shared.menu.ride.allAccepted' | translate }} </span>
      </a>
    </li>
    <li nz-menu-item nzMatchRouter>
      <a [routerLink]="[path(), 'marketplace']">
        <span nz-icon nzType="shop"></span>
        <span> {{ 'shared.menu.ride.marketplace' | translate }} </span>
      </a>
    </li>
  }
</ul>
